import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchTip: {
		id: 'servicedesk-customers-organization-common.search.search-tip',
		defaultMessage: 'Customer not found? Try refining your search.',
		description: 'Open tip placed next to search input to refine search',
	},
});
